module.exports = __webpack_public_path__ + "img/benefit_obj.0b5a4635.jpg";